import isEmpty from 'lodash/isEmpty';
import { fetchRetailerDetails } from 'utils/actions/utils.actions';

import template from './side-menu-header.html';

const mapStateToThis = ({ retailerDetails, session }) => {
  const { retailers } = session;
  const isEmptyRetailerDetails = isEmpty(retailerDetails);

  return {
    isEmptyRetailerDetails,
    retailerDetails,
    retailers,
  };
};

const mapDispatchToThis = {
  fetchRetailerDetails,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state')
class SideMenuHeaderController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    await this.fetchRetailerDetails(this.$state.params.retailerNo);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class SideMenuHeaderComponent {
  constructor() {
    this.controller = SideMenuHeaderController;
    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/side-menu/components/side-menu-header/side-menu-header-component.js